export const LOGIN_USER = "login_user";
export const LOGOUT_USER = "logout_user";
export const GET_ERROR = "error"
export const CREATE_NETWORK = "create_network"
export const SET_NETWORK_LIST = "set_network_list"
export const GET_NETWORK_LIST = "get_networks_list"
export const SET_CONNECTION_STATUS = "set_connection_status"
export const AUTH_TYPES = "get_auth_types"